/**
 * Professional Mode Toggle
 * Manages the professional mode state across the site
 */
(function() {
  'use strict';

  const PRO_MODE_KEY = 'drucker_pro_mode';
  const PRO_MODE_CLASS = 'pro-mode';

  /**
   * Check if pro mode is enabled
   */
  function isProModeEnabled() {
    return localStorage.getItem(PRO_MODE_KEY) === 'true';
  }

  /**
   * Enable pro mode
   */
  function enableProMode() {
    localStorage.setItem(PRO_MODE_KEY, 'true');
    document.body.classList.add(PRO_MODE_CLASS);
    updateAllToggles(true);
  }

  /**
   * Disable pro mode
   */
  function disableProMode() {
    localStorage.setItem(PRO_MODE_KEY, 'false');
    document.body.classList.remove(PRO_MODE_CLASS);
    updateAllToggles(false);
  }

  /**
   * Toggle pro mode
   */
  function toggleProMode() {
    if (isProModeEnabled()) {
      disableProMode();
    } else {
      enableProMode();
    }
  }

  /**
   * Update all toggle switches to reflect current state
   */
  function updateAllToggles(checked) {
    const toggles = document.querySelectorAll('#pro-mode-switch, .pro-mode-toggle__input');
    toggles.forEach(function(toggle) {
      toggle.checked = checked;
    });
  }

  /**
   * Initialize pro mode on page load
   */
  function initProMode() {
    // Apply saved state
    if (isProModeEnabled()) {
      document.body.classList.add(PRO_MODE_CLASS);
      updateAllToggles(true);
    }

    // Bind toggle events
    const toggles = document.querySelectorAll('#pro-mode-switch, .pro-mode-toggle__input');
    toggles.forEach(function(toggle) {
      toggle.addEventListener('change', function(e) {
        if (e.target.checked) {
          enableProMode();
        } else {
          disableProMode();
        }
      });
    });

    // Bind click handler for product page request info button
    bindRequestInfoButtons();

    // Bind click handler for finitions info tooltips
    bindFinitionsInfoButtons();
  }

  /**
   * Bind click handlers for request info buttons on product pages
   */
  function bindRequestInfoButtons() {
    const requestBtns = document.querySelectorAll('.pro-mode-request-info--product');
    requestBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const productTitle = btn.getAttribute('data-product-title');
        // For now, just log - will be replaced with modal/form later
        console.log('Request info for:', productTitle);
        // Could redirect to contact page with product info
        // window.location.href = '/pages/contact?product=' + encodeURIComponent(productTitle);
      });
    });
  }

  /**
   * Bind click handlers for finitions info tooltips on product cards
   */
  function bindFinitionsInfoButtons() {
    document.addEventListener('click', function(e) {
      const infoBtn = e.target.closest('.product-card__finitions-info');

      if (infoBtn) {
        e.preventDefault();
        e.stopPropagation();

        // Close all other tooltips
        document.querySelectorAll('.product-card__finitions-info.is-active').forEach(function(other) {
          if (other !== infoBtn) {
            other.classList.remove('is-active');
          }
        });

        // Toggle current tooltip
        infoBtn.classList.toggle('is-active');
      } else {
        // Click outside - close all tooltips
        document.querySelectorAll('.product-card__finitions-info.is-active').forEach(function(active) {
          active.classList.remove('is-active');
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProMode);
  } else {
    initProMode();
  }

  // Re-initialize after AJAX content loads (for infinite scroll, etc.)
  document.addEventListener('collection:rerendered', function() {
    if (isProModeEnabled()) {
      updateAllToggles(true);
    }
  });

  // Expose functions globally if needed
  window.DruckerProMode = {
    enable: enableProMode,
    disable: disableProMode,
    toggle: toggleProMode,
    isEnabled: isProModeEnabled
  };
})();
